import {api} from '../components/Base/App';

export default {
    contactOwner(objectId, request) {
        return api({
            method: 'post',
            url: `/rest/gw/site/object/${objectId}/contact-owner`,
            data: request
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/ObjectController.js